"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Button = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled");

var Button = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Button, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Button);

  function Button() {
    (0, _classCallCheck2["default"])(this, Button);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          flat = _this$props.flat,
          rounded = _this$props.rounded,
          ghost = _this$props.ghost,
          translucent = _this$props.translucent,
          raised = _this$props.raised,
          icon = _this$props.icon,
          fullWidth = _this$props.fullWidth,
          disablePadding = _this$props.disablePadding,
          info = _this$props.info,
          warning = _this$props.warning,
          vanilla = _this$props.vanilla,
          licorice = _this$props.licorice,
          disabled = _this$props.disabled,
          size = _this$props.size,
          onClick = _this$props.onClick,
          children = _this$props.children,
          type = _this$props.type,
          buttonRef = _this$props.buttonRef,
          className = _this$props.className,
          name = _this$props.name,
          value = _this$props.value;
      return /*#__PURE__*/_react["default"].createElement(_styled.StyledButton, {
        id: id,
        "data-testid": id,
        ref: buttonRef,
        flat: flat,
        raised: raised,
        rounded: rounded,
        translucent: translucent,
        ghost: ghost,
        type: type,
        size: size,
        disabled: disabled,
        icon: icon,
        fullWidth: fullWidth,
        disablePadding: disablePadding,
        onClick: disabled ? null : onClick,
        info: info,
        warning: warning,
        vanilla: vanilla,
        licorice: licorice,
        className: className,
        name: name,
        value: value
      }, children);
    }
  }]);
  return Button;
}(_react["default"].PureComponent);

exports.Button = Button;
Button.defaultProps = {
  children: null,
  flat: false,
  ghost: false,
  translucent: false,
  raised: false,
  rounded: false,
  info: false,
  warning: false,
  licorice: false,
  vanilla: false,
  icon: false,
  fullWidth: false,
  disablePadding: false,
  onClick: null,
  disabled: false,
  size: 'base',
  type: 'button',
  buttonRef: function buttonRef() {},
  className: '',
  name: undefined,
  value: undefined
};
var _default = Button;
exports["default"] = _default;